/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Button } from 'antd';

import cma from '../cma/cma';
import cmaJson from '../data/cma.json';

const cmaJsonObj = {
  PL: cmaJson.filter((entry) => (entry.cmaType === 'PL')),
  BS: cmaJson.filter((entry) => (entry.cmaType === 'BS')),
  CF: cmaJson.filter((entry) => (entry.cmaType === 'CF')),
  BSA: cmaJson.filter((entry) => (entry.cmaType === 'BSA')),
  MPBF: cmaJson.filter((entry) => (entry.cmaType === 'MPBF')),
  FFS: cmaJson.filter((entry) => (entry.cmaType === 'FFS')),
  KFP: cmaJson.filter((entry) => (entry.cmaType === 'KFP')),
};

const styles = {
  depth: {
    1: {
      paddingLeft: 10,
    },
    2: {
      paddingLeft: 20,
    },
  },
};

class EditCmaForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pl_values: this.props.pl_values,
      bs_values: this.props.bs_values,
      cf_values: this.props.cf_values,
      bsa_values: this.props.bsa_values,
      mpbf_values: this.props.mpbf_values,
      ffs_values: this.props.ffs_values,
      kfp_values: this.props.kfp_values,
      selectedKey: 'PL',
      auditedCount: 0,
      projectionCount: 0,
    };
  }

  componentWillMount() {
    const { fys } = this.props;
    let ac = 0;
    let pc = 0;
    fys.forEach((fy) => {
      if (fy.type === 'audited') ac++;
      if (fy.type === 'projection') pc++;
    });
    this.setState({
      auditedCount: ac,
      projectionCount: pc,
    });
  }

  getCmaEntryRows = () => {
    const { selectedKey } = this.state;
    const currentValues = `${selectedKey.toLowerCase()}_values`;

    return cmaJsonObj[selectedKey].map((entry) => (
      <tr key={entry.id}>
        <td style={styles.depth[entry.depth]}>{entry.sequence}. {entry.displayName}</td>
        {
          this.state[currentValues][entry.id].map((val, index) => (
            <td key={`${entry.id}_${index}`}>
              <input
                type="number"
                className="cma-inputs form-control"
                disabled={entry.systemType !== 'x'}
                value={val}
                onChange={(event) => {
                  const newValues = { ...this.state[currentValues] };
                  newValues[entry.id][index] = parseFloat(event.target.value);
                  this.setState({
                    [currentValues]: newValues,
                  });
                }}
              />
            </td>
          ))
        }
      </tr>
    ));
  };

  handleSubMenuClick = (e) => {
    this.setState({
      selectedKey: e.key,
    });
  };

  calculateCmaValues = () => {
    this.setState({
      ...cma(this.props.fys, this.state.pl_values, this.state.bs_values, this.state.cf_values, this.state.bsa_values, this.state.mpbf_values, this.state.ffs_values, this.state.kfp_values),
    });
  };

  render() {
    const { fys } = this.props;
    const { auditedCount, projectionCount } = this.state;

    return (
      <div>
        <Menu
          onClick={this.handleSubMenuClick}
          selectedKeys={[this.state.selectedKey]}
          mode="horizontal"
        >
          <Menu.Item key="PL">
            Form II
          </Menu.Item>
          <Menu.Item key="BS">
            Form III
          </Menu.Item>
          <Menu.Item key="CF">
            CashFlow
          </Menu.Item>
          <Menu.Item key="BSA">
            Form IV
          </Menu.Item>
          <Menu.Item key="MPBF">
            Form V
          </Menu.Item>
          <Menu.Item key="FFS">
            Form VI
          </Menu.Item>
          <Menu.Item key="KFP">
            Key Financial Parameters
          </Menu.Item>
        </Menu>
        <div>
          <table className="cma-table">
            <thead>
              <tr>
                <th rowSpan="2" className="cma-entry-name">Name</th>
                <th colSpan={auditedCount}>Audited</th>
                <th>Estmtd.</th>
                <th colSpan={projectionCount}>Projection</th>
              </tr>
              <tr>
                {
                  fys.map((fy) => (<th key={fy.year}>{fy.year}</th>))
                }
              </tr>
            </thead>
            <tbody>
              {
                this.getCmaEntryRows()
              }
            </tbody>
          </table>
          <br />
          <Button type="primary" onClick={this.calculateCmaValues}>Calculate Values</Button>
        </div>
      </div>
    );
  }
}

EditCmaForm.propTypes = {
  pl_values: PropTypes.object.isRequired,
  bs_values: PropTypes.object.isRequired,
  cf_values: PropTypes.object.isRequired,
  bsa_values: PropTypes.object.isRequired,
  mpbf_values: PropTypes.object.isRequired,
  ffs_values: PropTypes.object.isRequired,
  kfp_values: PropTypes.object.isRequired,
  fys: PropTypes.array.isRequired,
};

export default EditCmaForm;



// WEBPACK FOOTER //
// ./src/forms/EditCmaForm.jsx